import React from 'react';

interface BadgeCacheProps {
  cached: boolean;
  label?: string;
}

export function BadgeCache({ cached, label }: BadgeCacheProps) {
  if (!label) return null;
  return (
    <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full ${
      cached 
        ? 'bg-green-500/15 text-green-400' 
        : 'bg-yellow-500/15 text-yellow-400'
    }`}>
      {cached ? '✓' : '⚠'} {label}
    </span>
  );
}
